import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Card = styled.div`
  max-width: 224px !important;
  flex-shrink: 0;
  height: 100%;
  position: relative;
  transition-property: transform;
  border-radius: 10px;
  transition: all ease-out 0.5s;
  background: #fff;
  overflow: hidden;
  text-decoration: none;
  text-align: center;
  /* box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #fff; */
  margin: 0 10px;
  @media (max-width: 767px) {
    margin: 0 auto;
  }
  h4 {
    transition: all ease-out 0.5s;
    text-align: center;
    margin: 0;
    padding: 8.5px 0;
    font-size: 16px;
    color: ${COLORS.BLACK};
  }
  span {
    color: ${COLORS.BLACK};
    font-size: 13px;
    transition: all ease-out 0.5s;
  }
  img {
    width: 100%;
    max-width: 100%;
  }
  &:hover {
    cursor: pointer;
    background: transparent;
    h4 {
      background: #272742;
    }
    h4,
    span {
      color: ${COLORS.WHITE};
    }

    @media (min-width: 768px) {
      img {
        filter: grayscale(1);
        mix-blend-mode: screen;
      }
    }
  }
`;

export { Card };
